var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { extractClassNameProps, extractWidthProps, extractWrapperMarginProps } from '../../utils/extractProps';
import { useGeneratedId } from '../../utils/hooks/useGeneratedId';
import { BottomLinedInput } from './BottomLinedInput';
import { BottomLinedInputLabel } from './BottomLinedInputLabel';
import { BoxedInput } from './BoxedInput';
import { BoxedInputLabel } from './BoxedInputLabel';
import { InputWrapper } from './InputWrapper';
const InnerInput = forwardRef((props, ref) => {
    var _a, _b, _c;
    const { classNameProps, restProps: withoutClassName } = extractClassNameProps(props);
    const { marginProps, restProps: withoutMargin } = extractWrapperMarginProps(withoutClassName);
    const { widthProps, restProps } = extractWidthProps(withoutMargin);
    const { label, onChange, size, id: providedId, variant } = restProps, rest = __rest(restProps, ["label", "onChange", "size", "id", "variant"]);
    const id = useGeneratedId(providedId);
    const innerRef = useRef();
    useImperativeHandle(ref, () => innerRef.current, []);
    const [hasValue, setHasValue] = useState(((_a = rest === null || rest === void 0 ? void 0 : rest.value) === null || _a === void 0 ? void 0 : _a.toString().length) > 0);
    const hasUncontrolledValue = ((_c = (_b = innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.length) > 0;
    const handleChange = (event) => {
        setHasValue(event.target.value.length > 0);
        if (onChange) {
            onChange(event);
        }
    };
    useEffect(() => {
        var _a;
        setHasValue(((_a = rest === null || rest === void 0 ? void 0 : rest.value) === null || _a === void 0 ? void 0 : _a.toString().length) > 0);
    }, [rest.value]);
    if (variant === 'boxed') {
        return (React.createElement(InputWrapper, Object.assign({}, classNameProps, marginProps, widthProps),
            React.createElement(BoxedInput, Object.assign({}, rest, { ref: innerRef, variant: variant, id: id, waveSize: size, hasValue: hasValue || hasUncontrolledValue, onChange: handleChange, "aria-invalid": rest.error })),
            label && (React.createElement(BoxedInputLabel, { htmlFor: id, waveSize: size }, label))));
    }
    if (variant === 'bottom-lined') {
        return (React.createElement(InputWrapper, Object.assign({}, classNameProps, marginProps, widthProps),
            React.createElement(BottomLinedInput, Object.assign({}, rest, { ref: innerRef, variant: variant, id: id, waveSize: size, hasValue: hasValue || hasUncontrolledValue, onChange: handleChange, "aria-invalid": rest.error })),
            label && (React.createElement(BottomLinedInputLabel, { htmlFor: id, waveSize: size }, label))));
    }
    return undefined;
});
InnerInput.defaultProps = {
    size: 'medium',
    variant: 'boxed',
    type: 'text'
};
export { InnerInput };
